import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-1.png'


_pushScopeId("data-v-0180f312")
const _hoisted_1 = { class: "footer-top" }
const _hoisted_2 = {
  key: 0,
  class: "template2 flex-align flex-justify"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "default"
}
const _hoisted_5 = {
  key: 2,
  class: "template3 common_mgb16 flex-align flex-justify"
}
const _hoisted_6 = { class: "left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "common_mgb16" }, "联系方式", -1)
const _hoisted_8 = { class: "flex-align" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "font32 font_family icon-weibo" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "font32 font_family icon-QQCopy" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "wechat common_pointer"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "font32 font_family icon-weixin" }, null, -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_19 = { class: "right" }
const _hoisted_20 = { class: "font16 common_mgb32" }
const _hoisted_21 = { class: "font16" }
const _hoisted_22 = { class: "copyright font12 text-center" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Copyright © ")
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "footer-bottom text-center font12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "common_mgr8",
    alt: "课堂派"
  }),
  /*#__PURE__*/_createTextVNode("课堂派提供技术支持")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", {
    class: "portal-footer",
    style: _normalizeStyle({ backgroundColor: !_ctx.isMobile && _ctx.footerData.basecolor })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.footerData.default_name === 'template1')
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentData.nav_lists, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.link_id,
                class: "common_pointer",
                onClick: ($event: any) => (_ctx.jumpLink(item))
              }, _toDisplayString(item.title), 9, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.footerData.default_name === 'default')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.footerData.default_name === 'template2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_ctx.currentData.show_sina)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.currentData.sina_url,
                      class: "sina common_pointer common_mgr32"
                    }, _hoisted_11, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                (_ctx.currentData.show_qq)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: '//wpa.qq.com/msgrd?v=3&uin=' + _ctx.currentData.qq_url + '&site=qq&menu=yes',
                      target: "_blank",
                      class: "qq common_pointer common_mgr32"
                    }, _hoisted_14, 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.currentData.show_wechat)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("img", {
                        src: _ctx.currentData.wechat_img,
                        class: "transition200ms",
                        alt: ""
                      }, null, 8, _hoisted_17)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.currentData.text1), 1),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.currentData.text2), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("span", {
          innerHTML: _ctx.currentData.copyright
        }, null, 8, _hoisted_24)
      ])
    ]),
    _hoisted_25
  ], 4))
}